/* eslint-disable no-magic-numbers */
import { Option, Select } from 'carbon-react/lib/components/select';
import React from 'react';

import { useIntl } from '@futrli/localisation';
import { getOrdinalSuffix } from '@futrli/localisation/core/utils';

import { adaptSelectChange } from '../../../../utils/carbon-select';

interface DayOfMonthMenuProps {
  className?: string;
  disabled?: boolean;
  label?: {
    id: string;
    defaultMessage: string;
  };
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  error?: boolean;
  size?: 'small' | 'medium' | 'large';
}

const dates = [...Array(32).keys()].slice(1);

export const DayOfMonthMenu = ({
  disabled = false,
  label,
  onChange,
  value,
  error,
  size = 'large'
}: DayOfMonthMenuProps) => {
  const intl = useIntl();

  const formattedLabel = intl.formatMessage(
    label || {
      id: 'predict.output_on_day',
      defaultMessage: 'Output on day'
    }
  );

  return (
    <div style={{ width: 200, marginRight: 16 }}>
      <Select
        value={value ?? ''}
        onChange={adaptSelectChange(onChange)}
        label={formattedLabel}
        data-testid="DayOfMonthMenu"
        autoComplete="off"
        disabled={disabled}
        error={error}
        size={size}
        mb={0}
      >
        <Option
          value="32"
          text={intl.formatMessage({ id: 'predict.last_day_of_month', defaultMessage: 'Last day of the month' })}
        />
        {dates.map(date => (
          <Option key={date} value={String(date)} text={getOrdinalSuffix(date, intl.locale)} />
        ))}
      </Select>
    </div>
  );
};
